import Breadcrumb from "components/Breadcrumb";
import LessonsAndFreeplay from "./LessonsAndFreeplay";
import ToolBar from "./ToolBar";
import { useAppSelector } from "app/hooks";
import { selectIsPrinting } from "features/Reports";
import QuestionsStatistic from "./QuestionsStatistic";
import GuidedReading from "./GuidedReading";
import { Typography } from "@mui/material";
import TeacherStudentUsage from "./TeacherStudentUsage";

const customStyles = {
  root: {
    margin: "20px 0",
    borderRadius: "2px",
    boxShadow: "0 2px 4px 0 rgba(179, 187, 199, 1)",
    background: "rgba(255, 255, 255, 1)",
    width: "100%",
  },
  printing: {
    margin: "0 auto",
    padding: 0,
    boxShadow: "none",
  },
};

interface IProps {}
const OtherReports = (props: IProps) => {
  const isPrinting = useAppSelector(selectIsPrinting);
  return (
    <>
      <Breadcrumb />
      <ToolBar />
      <Typography
        component="div"
        sx={{
          ...customStyles.root,
          ...(isPrinting ? customStyles.printing : {}),
        }}
      >
        <GuidedReading />

        <TeacherStudentUsage />
        <LessonsAndFreeplay />
        <QuestionsStatistic />
      </Typography>
    </>
  );
};

export default OtherReports;
